import { decodeStega } from 'react-datocms';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { VideoContent } from 'components/VideoContent/VideoContent';
import { Image } from 'services/graphql';

import styles from './VideoBlock.module.css';

interface VideoBlockRecord extends CdaStructuredTextRecord {
  video: { url: string; title: string; thumbnailUrl?: string };
  image?: Image;
}

export default function VideoBlock({ video, image }: VideoBlockRecord) {
  const editingUrl = decodeStega(video.title) || (image?.alt && decodeStega(image.alt)) || null;

  return (
    <div
      className={styles.video}
      data-datocms-content-link-url={editingUrl?.href}
    >
      <VideoContent
        key={`${video.url}:${image?.url || video.thumbnailUrl || ''}`}
        video={video}
        image={image}
      />
    </div>
  );
}
